var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 24,
    viewBox: "0 0 137 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62.6988 22.5282C61.0835 23.2949 59.091 23.9467 56.172 23.9467C50.0674 23.9467 45.4634 20.0765 45.4634 14.218C45.4634 8.35942 50.3462 4.48926 56.422 4.48926C58.722 4.48926 60.9113 5.04682 62.3995 5.72738L62.1043 9.09328C60.8826 8.51111 58.9311 7.96585 56.7582 7.96585C52.6872 7.96585 49.4032 10.1387 49.4032 14.1852C49.4032 18.0267 52.433 20.5439 56.6844 20.5439C58.8327 20.5439 60.7842 20.015 62.1576 19.1951L62.6906 22.52L62.6988 22.5282Z",
    fill: "#0C0C54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M73.2065 21.905C72.3907 23.0734 70.7508 23.9508 68.9141 23.9508C66.3189 23.9508 64.4084 22.4749 64.4084 19.9863C64.4084 17.219 66.8355 15.8824 70.472 15.8824C71.5543 15.8824 72.4645 16.0341 73.1245 16.2022V15.5914C73.1245 13.8777 72.0176 13.1848 69.9103 13.1848C68.295 13.1848 66.4706 13.685 65.5031 14.2302L65.1505 11.1964C66.1344 10.6389 68.1966 10.0403 70.3695 10.0403C74.4529 10.0403 76.7118 11.7376 76.7118 15.3126V23.6761H73.2721L73.2024 21.9091L73.2065 21.905ZM73.0507 18.8589V18.289C72.4604 18.1209 71.7019 17.9815 70.7057 17.9815C69.1191 17.9815 67.9547 18.5104 67.9547 19.6501C67.9547 20.7202 68.7952 21.249 70.0333 21.249C71.5215 21.249 72.9647 20.3307 73.0507 18.8548",
    fill: "#0C0C54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M83.575 4.07928H79.9836V23.672H83.575V4.07928Z",
    fill: "#0C0C54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M90.5648 4.07928H86.9734V23.672H90.5648V4.07928Z",
    fill: "#0C0C54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M98.088 18.1046V23.672H94.2998V4.77625H103.127C106.972 4.77625 110.072 7.18281 110.072 11.4712C110.072 15.5217 106.968 18.1087 103.127 18.1087H98.088V18.1046ZM98.088 8.03146V14.8658H102.692C104.697 14.8658 106.173 13.4882 106.173 11.4712C106.173 9.27369 104.672 8.03556 102.692 8.03556H98.088V8.03146Z",
    fill: "#0C0C54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M116.049 12.1353C116.738 10.7455 118.041 10.0362 119.558 10.0362C120.358 10.0362 121.03 10.2453 121.313 10.3437L121.034 13.5292C120.669 13.4021 120.079 13.2217 119.366 13.2217C117.779 13.2217 116.11 14.0704 116.11 16.8254V23.672H112.503V10.315H115.983L116.053 12.1394L116.049 12.1353Z",
    fill: "#0C0C54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M129.463 10.0321C133.604 10.0321 136.663 13.0536 136.663 16.9894C136.663 20.9252 133.604 23.9467 129.463 23.9467C125.323 23.9467 122.264 20.9416 122.264 16.9894C122.264 13.0372 125.339 10.0321 129.463 10.0321ZM129.463 20.7202C131.583 20.7202 133.083 19.1336 133.083 16.9894C133.083 14.8452 131.583 13.275 129.463 13.275C127.344 13.275 125.843 14.8616 125.843 16.9894C125.843 19.1172 127.36 20.7202 129.463 20.7202Z",
    fill: "#0C0C54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.04939 6.72363C4.24037 6.72363 0.337402 10.5897 0.337402 15.3618C0.337402 18.5063 2.0306 21.2573 4.56425 22.766L10.4146 6.83023C9.97185 6.76053 9.51267 6.72363 9.04939 6.72363Z",
    fill: "#0054A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M29.7243 16.272C30.5566 14.0007 32.7458 12.4838 35.1811 12.4838C35.4517 12.4838 35.7141 12.5043 35.9764 12.5412C36.0871 12.0615 36.1487 11.5572 36.1487 11.0448C36.1487 7.35908 33.0902 4.32526 29.3717 4.32526C28.8593 4.32526 28.355 4.38265 27.8671 4.49335C25.6615 4.99352 23.8043 6.57602 23.0048 8.7448L17.4045 24H26.8832L29.7202 16.272H29.7243Z",
    fill: "#008FD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M35.9766 12.5371C35.7183 12.5002 35.4518 12.4797 35.1813 12.4797C32.746 12.4797 30.5567 14.0007 29.7245 16.2678L26.8875 23.9959H35.1813C38.3668 23.9959 40.9865 21.3967 40.9865 18.2357C40.9865 15.3454 38.7891 12.9225 35.9725 12.533",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M19.6962 0.00410376C15.6374 0.00410376 11.9886 2.53775 10.6029 6.31773L10.4143 6.8261L4.56396 22.7619C5.87589 23.5449 7.4092 23.9959 9.0491 23.9959H17.4085L23.0088 8.74069C23.8041 6.57192 25.6613 4.98941 27.8711 4.48924C26.1492 1.7998 23.1195 0 19.7003 0",
    fill: "#0072BC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.416440fecf97fcecee22182aec04bd6b.svg";
export { ForwardRef as ReactComponent };